import React, { useState, useCallback } from 'react';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useAuth } from '../../contexts/auth';
import { SingleCard } from '../../layouts';
import Toast from '../Toast';
import LogoLight from '../../assets/asafeLogoLight.png';
import LogoDark from '../../assets/asafeLogoDark.png';
import { useTheme } from 'contexts/theme';
import './tenancy-selection.scss';

export default function TenancySelection() {
  const { pendingSelection, selectTenancy } = useAuth();
  const { theme } = useTheme();
  const Logo = theme === 'dark' ? LogoDark : LogoLight;
  const [loadingId, setLoadingId] = useState(null);
  const [selectedId, setSelectedId] = useState('');
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: 'error',
    message: '',
    displayTime: 3000,
  });

  const onSelect = useCallback(async (tenantId) => {
    setLoadingId(tenantId);
    const result = await selectTenancy(pendingSelection.preAuthToken, tenantId);
    if (!result.isOk) {
      setLoadingId(null);
      setToastConfig(cfg => ({ ...cfg, isVisible: true, message: result.message }));
    }
  }, [pendingSelection, selectTenancy]);

  return (
    <>
      <div className='logo_img'>
        <img src={Logo} alt='A-SAFE' />
      </div>
      <SingleCard title="Select a Tenancy">
        <p className="tenancy-selection__description">
          Please select the account you want to access.
        </p>
        <div className="tenancy-selection__form">
          <select
            className="tenancy-selection__select"
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            disabled={loadingId !== null}
          >
            <option value="" disabled>-- Select an account --</option>
            {pendingSelection.tenancies.map((tenancy) => (
              <option key={tenancy.id} value={tenancy.id}>{tenancy.name}</option>
            ))}
          </select>
          <button
            className="tenancy-selection__button"
            disabled={loadingId !== null || !selectedId}
            onClick={() => onSelect(selectedId)}
          >
            {loadingId
              ? <LoadIndicator width="20px" height="20px" visible={true} />
              : 'Continue'}
          </button>
        </div>
      </SingleCard>
      <Toast setParentToastConfig={setToastConfig} toastBody={toastConfig} />
    </>
  );
}
